@if (variant === 'compact') {
    <div class="help-section-compact">
        <div class="compact-text">
            <div class="compact-title">{{ 'thematicStrategyLanding.faq.title' | translate }}</div>
            <div class="compact-description">{{ 'thematicStrategyLanding.faq.description' | translate }}</div>
            <liberro-show-more-link
                [label]="'thematicStrategyLanding.faq.cta' | translate"
                [link]="faqOverviewUrl"
                suffixIcon="pointing-arrow.svg"
            ></liberro-show-more-link>
        </div>
        <div class="compact-faq-list">
            <liberro-faq [faqList]="faqList"></liberro-faq>
        </div>
    </div>
} @else if (variant === 'default') {
    <div class="help-section-container" [ngClass]="{'help-section-container--column': displayInColumn}">
        <div class="may-we-advise-section" [ngClass]="{'may-we-advise-section--column': displayInColumn}">
        <div class="help-title">{{ 'dashboard.help.mayWeAdviseTitle' | translate }}</div>
        <div class="help-description">{{ 'dashboard.help.mayWeAdviseDescription' | translate }}</div>
        <liberro-faq
            [faqList]="faqList"
            [showMoreLinkLabel]="'dashboard.faqMoreLink' | translate"
            [showMoreLinkUrl]="faqOverviewUrl"
            [alwaysCenter]="displayInColumn"
        ></liberro-faq>
        </div>
            <div class="quick-help-section" [ngClass]="{'quick-help-section--column': displayInColumn}">
                <div class="help-title">{{ 'dashboard.help.quickHelpTitle' | translate }}</div>
                <div class="help-description">{{ 'dashboard.help.quickHelpDescription' | translate }}</div>
                <div class="quick-help-action-buttons" [ngClass]="{'quick-help-action-buttons--column': displayInColumn}">
                    <a [attr.href]="'mailto:' + ('login.highlighted-info.email' | translate)">
                    <liberro-button
                        [label]="'dashboard.help.writeUs' | translate"
                        widthType="responsive"
                        [customWidth]="desktopButtonWidths ?? ''"
                    ></liberro-button></a>
                    <liberro-button
                        [label]="'dashboard.help.myConsultant' | translate"
                        widthType="responsive"
                        type="primary"
                        [routerLink]="collaboratorRoute"
                        [customWidth]="desktopButtonWidths ?? ''"
                    ></liberro-button>
                </div>
            </div>
    </div>
}
